export const gebaeudeSearchModeName = 'searchMode';
export type GebaeudeSearchMode = 'searchStandard' | 'searchEgidKantgid';
